import { SettingsSort } from '@griply/assets';
import { useUpdateUserSettings } from 'features/user';
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton } from 'shared/components/ui/icon-button';
import {
  PopupMenu,
  PopupMenuList,
  PopupMenuListItem,
  PopupMenuToggle,
} from 'shared/components/ui/popup-menu';
import { useOpenMenu } from 'shared/hooks/use-open-menu';
import { useUser } from 'shared/hooks/use-user';

export const ExtraOptionsMenu: React.FC = () => {
  const { t } = useTranslation();
  const buttonRef = useRef<HTMLButtonElement>(null);
  const { menuOpen, openMenu, closeMenu } = useOpenMenu();

  const user = useUser();
  const updateUserSettings = useUpdateUserSettings();
  const showCompletedProjects =
    user?.settings?.projectsOverview?.roadmap?.showCompletedProjects ?? true;

  const onShowCompletedProjects = (value: boolean) => {
    updateUserSettings({
      projectsOverview: { roadmap: { showCompletedProjects: value } },
    });
  };

  return (
    <>
      <IconButton
        ref={buttonRef}
        icon={SettingsSort}
        strokeWidth={2}
        onClick={openMenu}
        highlighted={menuOpen}
        preventDrag
      />
      {menuOpen && (
        <PopupMenu
          referenceElement={buttonRef}
          onOutside={closeMenu}
          position="bottom-end"
        >
          <PopupMenuList>
            <PopupMenuListItem>
              <PopupMenuToggle
                label={t('general.labels.projects.show-completed-projects')}
                checked={showCompletedProjects}
                onChange={onShowCompletedProjects}
              />
            </PopupMenuListItem>
          </PopupMenuList>
        </PopupMenu>
      )}
    </>
  );
};
